<template>
  <div class="container">
    <div class="nav" :style="{ width: isCollapse ? '60px' : '210px' }">
      <div class="logo">
        <!-- <img src="@/assets/logo.svg" alt="" width="210px" height="30px" style="margin-top: 12px;transform: scale(0.8);" /> -->
        <svg-icon
          className="icon"
          iconClass="logo"
          style="    width: 210px;
    height: 40px;
    margin-top: 5px;"></svg-icon>
      </div>
      <Nav ref="nav" style="height: calc(100% - 55px);"></Nav>
    </div>
    <div
      class="main"
      :style="{
        width: isCollapse ? 'calc(100% - 60px)' : 'calc(100% - 210px)'
      }">
      <!-- <div class="header">
        <Header class="header-content"></Header>
      </div> -->
      <div
        class="content"
      >
        <div class="alive-item">
          <alive-nav></alive-nav>
        </div>
        <div class="page">
          <keep-alive>
            <router-view />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from './components/Header.vue'
import Nav from './components/Nav.vue'
import { mapGetters } from 'vuex'
import AliveNav from './components/AliveNav.vue'
import * as signalR from '@microsoft/signalr'
import feepowerIcon from '@/assets/feepowerIcon.png'
export default {
  components: { Nav, AliveNav },
  computed: {
    ...mapGetters(['isCollapse', 'deriveLoading'])
  },
  created() {
    this.init()
  },
  methods: {
    // 唤起浏览器弹框 前提浏览器得允许弹框通知显示
    showMsg(msg) {
      const that = this
        // 如果支持window.Notification 并且 许可不是拒绝状态
        if (window.Notification && Notification.permission !== 'denied') {
          // Notification.requestPermission这是一个静态方法，作用就是让浏览器出现是否允许通知的提示
          Notification.requestPermission(function(status) {
            // 如果状态是同意
            if (status === 'granted') {
              const m = new Notification(msg.title, {
                body: msg.body, // 消息体内容
                icon: feepowerIcon // 消息图片
              })
              // 点击当前消息内容
              m.onclick = function() {
                // 点击当前消息提示框后，跳转到当前页面
                // that.$router.push({ path: '/Reception/chatpage' })
                window.focus()
              }
              // 点击关闭消息提示框
              m.onclose = function() {
                m.close()
              }
            } else {
              that.$notify('当前浏览器不支持弹出消息')
            }
          })
        }
    },
    init() {
      // 构建服务通讯连接对象
      // 本地测试：http://localhost:9990/
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl('/Hub/JobBenchHub', {
          // skipNegotiation: true, // 关键
          // transport: signalR.HttpTransportType.WebSockets // 关键
        })
        .withAutomaticReconnect([0, 2000, 10000, 30000]) // 添加重连间隔参数
        .configureLogging(signalR.LogLevel.Information)
        .build()

      // 正式建立连接
      this.connection
        .start()
        .then(function() {
          console.log('正式建立连接')
        })
        .catch(function(err) {
          return console.error(err)
        })

      //   // 重新连接监听
      //   connection.on('Show', res => {
      //     // 可以做相关业务逻辑
      //     console.log('signalr 来了', message)
      // })
      this.connection.on('UserMessage', (message) => {
        console.log('signalr 来了', message)
        const msg = JSON.parse(message)
        switch (msg.type) {
          case 0:
            // 消息
            this.$store.commit('SET_ISNEWMSG', true)
            this.showMsg({
              title: '有新消息',
              body: msg.description
            })
            break
          case 1:
            // 代办
            this.$store.commit('SET_ISNEWUPCOME', true)
            this.showMsg({
              title: '有新待办',
              body: msg.description
            })
            break
          case 2:
            // 工单
            this.$store.commit('SET_ISNEWWORKBILL', true)
            this.showMsg({
              title: '有新工单',
              body: msg.description
            })
            break
          default:
            break
        }
      })

      // 邮件推送
      this.connection.on('receiveEmail', (message) => {
        this.$root.$emit('receiveEmail', message)
        // 刷新导航栏邮件文件夹数量
        this.$refs.nav && this.$refs.nav.initEmailFolder()
      })

      // 监听广播的消息(费用试算)
      this.connection.on('UserSchedule', (message) => {
        console.log('signalr 来了', message)
        const msg = JSON.parse(message)
        switch (msg.type) {
          case 0:
            // 消息
            this.$store.commit('SET_ISNEWMSG', true)
            this.showMsg({
              title: '有新消息',
              body: msg.description
            })
            break
          case 1:
            // 代办
            this.$store.commit('SET_ISNEWUPCOME', true)
            this.showMsg({
              title: '有新待办',
              body: msg.description
            })
            break
          case 2:
            // 工单
            // this.$store.commit('CHANGE_UPCOME_DRAWER', true)
            break
          default:
            break
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  .logo {
    width: 210px;
    height: 55px;
    background-color: #fff;
  }
  .nav {
    width: 210px;
    height: 100%;
    width: 210px;
    background: #304156;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    z-index: 999;
  }
  .main {
    width: 100%;
    height: 100%;
    position: relative;

    .header {
      width: 100%;
      height: 50px;
      overflow: hidden;
      position: relative;
      background: #fff;
      -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
      box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    }
    .content {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .alive-item {
      width: 100%;
      height: 50px;
      width: 100%;
      background: #fff;
      border-bottom: 1px solid #d8dce5;
      -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
    }
    .page {
      height: calc(100% - 64px);
      width: calc(100% - 20px);
      background: #f7f7f7;
      padding: 10px;
    }
  }
}
</style>
